export default "__VITE_ASSET__d1e48a84__"